import React, { createContext } from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { getCurrentLanguage } from '../../../../common/components/LanguageSelector/duck'
import { userWorkSelector } from '../../../../student/sharedDucks/TestItem'

const HighlightableContentContext = createContext({})

const HighlightableContentProvider = ({
  children,
  userWork,
  isStudentAttempt,
  disableResponse,
  setItemHighlights,
  utaPreferredLanguage,
  isLCBView,
  isExpressGrader,
  isStudentReport,
  studentLanguagePreference,
  currentLanguage,
  isHighlighterToolVisible,
  isTestPreview = false,
  playerSkinType,
  currentTestItem,
}) => {
  return (
    <HighlightableContentContext.Provider
      value={{
        userWork,
        isStudentAttempt,
        disableResponse,
        setItemHighlights,
        utaPreferredLanguage,
        isLCBView,
        isExpressGrader,
        isStudentReport,
        studentLanguagePreference,
        currentLanguage,
        isHighlighterToolVisible,
        isTestPreview,
        playerSkinType,
        currentTestItem,
      }}
    >
      {children}
    </HighlightableContentContext.Provider>
  )
}

const enhanced = compose(
  connect(
    (state) => ({
      userWork: userWorkSelector(state),
      currentLanguage: getCurrentLanguage(state),
    }),
    null
  )
)

const enhancedHighlightableContentProvider = enhanced(
  HighlightableContentProvider
)

export {
  enhancedHighlightableContentProvider as HighlightableContentProvider,
  HighlightableContentContext,
}
